
import Button from "../../../components/ui/Button";

interface QuickAction {
  id: string;
  label: string;
  icon: string;
  action: () => void;
  variant: "default" | "outline" | "secondary";
}

interface QuickContactActionsProps {
  actions: QuickAction[];
}

const QuickContactActions = ({ actions }: QuickContactActionsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {actions.map((action) => (
        <Button
          key={action.id}
          variant={action.variant}
          size="lg"
          iconName={action.icon}
          iconPosition="left"
          onClick={action.action}
          fullWidth
          className="justify-start"
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickContactActions;